export default __webpack_public_path__ + "static/media/Switch.33aa6c5c.svg";